import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';
import { AxiosResponse } from 'axios';

interface GiftCardPayload {
    CardNumber: string;
    PIN: string;
}

interface GiftCardResponse {
    balance: number;
    currency?: string;
    message?: string;
}

export const useGiftCardBalance = () => {
    const base = '/api/v2/';
    const cookie: Cookie = new Cookie();
    const lang = cookie.Language.substring(0, 2) || 'en';
    const queryClient = useQueryClient();

    return useMutation<AxiosResponse<GiftCardResponse>, Error, GiftCardPayload>({
        mutationFn: async (payload) => {
            const response = await http.post(`${base}${lang}/giftcardbalance`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${cookie.UserAccessToken?.Edp ?? ''}`,
                },
                withCredentials: true,
            });
            return response;
        },
        onSuccess: (response) => {
            queryClient.setQueryData(['giftcardBalance'], response.data);
        },
        onError: (error) => {
            console.error('Gift card balance check failed:', error.message);
        },
    });
};
